import { defineComponent, h } from 'vue';

var _sfc_main = defineComponent({
  setup() {
    return () => h();
  }
});

export { _sfc_main as default };
